module.exports = __webpack_public_path__ + "static/favicon-076632d667dc99ee86e496036173a6ad.ico";